<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"background: #fff;\n"' class="container-fluid mt-5" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-12 text-center mt-4" >
                <template #default>   <m-h3 v-bind='{...{},...{}}' :style='""' class="mt-4" >
                <template #default>رضایت مشتریان میزلاین   </template>
                </m-h3></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-12 text-center mt-4" >
                <template #default>   <m-h4 v-bind='{...{},...{}}' :style='""' class="h6" >
                <template #default>مشتریانی که میز لاین اعتماد کردند :)   </template>
                </m-h4></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='"margin-top: 50px "' class="col-12 home-comment-section" >
                <template #default>   <m-content-slider-4 v-bind='{...{"cardLink":true,"contentCategory":["\u0646\u0638\u0631\u0627\u062a"],"contentType":"post","slicer":12,"itemClass":"col-lg-4 my-2 ","waitForCategoryProp":true,"categoryColumnProp":"slug","contentCard":"mContentCard915","sliderPagination":false,"swiperPerViewSM":1,"swiperPerViewMD":2,"swiperPerViewLG":4,"swiperPerViewSpaceBetweenSM":30,"swiperPerViewSpaceBetweenMD":30,"swiperPerViewSpaceBetweenLG":30,"sliderGridStatus":false,"sliderGridRows":2,"sliderLoop":true,"contentDirectLinkOn":false},...{}}' :style='""' class="card-container-923 comment-section-wrapper" ></m-content-slider-4></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH3 from '@moeinmdn/miw-alpha-components/src/package/Tags/H3'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4'; import mContentSlider4 from '@moeinmdn/miw-alpha-components/src/package/Content/Slider/ContentSlider4';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH3,mH4,mContentSlider4 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
